import { makeStyle } from '../../../../../utils';
import { columnCenter, subTitle1, black, bold, caption, secondary, h6, rowCenter, subTitle2 } from '../../../../../resources/styles';

const styles = {};

styles['header'] = makeStyle([rowCenter, {
    justifyContent: 'space-between', padding: '10px 10px 10px 22px'
}], { padding: '20px 20px 20px 32px' });

styles['title'] = makeStyle([h6, black, { letterSpacing: '-0.35px' }]);

styles['image_container'] = makeStyle({ minHeight: 266, overflow: 'auto hidden', padding: '0 22px' }, { padding: '0 32px' });

styles['image'] = makeStyle({ height: 266, width: 639.328, borderRadius: 10 });

styles['content'] = makeStyle([subTitle2, black, { margin: 22, paddingLeft: 15 }], { margin: 32 });

styles['text'] = makeStyle([subTitle2, black]);

export default styles;